import React from 'react';
import { Box, Typography } from '@mui/material';
import { useTheme } from '../../contexts/ThemeContext';

interface LogoProps {
  size?: 'small' | 'medium' | 'large';
  showText?: boolean;
  variant?: 'light' | 'dark';
}

export const Logo: React.FC<LogoProps> = ({ 
  size = 'medium', 
  showText = true,
  variant 
}) => {
  const { resolvedMode } = useTheme();

  const effectiveVariant: 'light' | 'dark' = variant ?? resolvedMode;
  const logoSizes = {
    small: { width: 24, height: 24 },
    medium: { width: 30, height: 30 },
    large: { width: 36, height: 36 },
  };

  const textSizes = {
    small: 'h5',
    medium: 'h4',
    large: 'h3',
  } as const;

  const gapSizes = {
    small: 2.5,
    medium: 2,
    large: 1
  };

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: showText ? gapSizes[size] : 0 }}>
      <Box
        component="img"
        src = {effectiveVariant === 'light' ? '/assets/images/rashid-logo.svg' : '/assets/images/rashid-logo-dark.svg'}
        alt="Rash ID Logo"
        sx={logoSizes[size]}
      />
      
      {showText && (
        <Typography 
          variant={textSizes[size]}
          component="div"
          sx={{ 
            fontFamily: '"Prompt", sans-serif',
            fontWeight: 500,
            letterSpacing: '-0.02em',
            wordSpacing: '-0.1em',
            color: (theme) => theme.palette.text.primary,
            lineHeight: 1,
          }}
        >
          Rash ID Lab
        </Typography>
      )}
    </Box>
  );
};